<template>
    <accordion-setting
        id="settingsImage"
        title="Configurações Imagem"
        :visible="visible"
    >
        <!-- CONFIGURAÇÃO DE LARGURA -->
        <div class="py-2">
            <setting-frame-width
                :item="item"
                @onChangeWidth="onChangeWidth"
            />
        </div>

        <!-- CONFIGURAÇÃO DE PREVIEW DA IMAGEM E TROCAR IMAGEM -->
        <div class="py-2">
			Esquerda
            <setting-frame-image
                :url="urlBefore"
                :externalImage="isExternalImageBefore"
                @onChangeImage="onChangeImageBefore"
            />
        </div>

        <!-- CONFIGURAÇÃO DE PREVIEW DA IMAGEM E TROCAR IMAGEM -->
        <div class="py-2">
			Direita
            <setting-frame-image
                :url="urlAfter"
                :externalImage="isExternalImageAfter"
                @onChangeImage="onChangeImageAfter"
            />
        </div>
    </accordion-setting>
</template>

<script>
import AccordionSetting from '../atoms/AccordionSetting.vue';

import SettingFrameWidth from "../atoms/SettingFrameWidth.vue";
import SettingFrameImage from '../atoms/SettingFrameImage.vue';

export default {
    name: "SettingsFrameImageAfterBefore",
    components: {
        AccordionSetting,
        SettingFrameWidth,
        SettingFrameImage,
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        visible: {
            type: Boolean,
            default: true
        },
        isChild: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        }
    },  
    computed: {
        urlBefore() {
          if (this.item.frameContent.beforePicture) return this.item.frameContent.beforePicture;
        },
        urlAfter() {
          if (this.item.frameContent.afterPicture) return this.item.frameContent.afterPicture;
        },
        isExternalImageBefore() {
          if (this.item.frameContent.beforePicture.includes('before-after-mockup-')) return true;

          return false;
        },
        isExternalImageAfter() {
          if (this.item.frameContent.afterPicture.includes('before-after-mockup-')) return true;

          return false;
        },
    },
    methods: {
        handleSaveFrameConfig() {
            this.$emit("saveItemChanges", this.item);
        },
        onChangeWidth(item) {
            this.item.grid = item.grid;
            this.item.gridMobile = item.gridMobile;
                            
            this.handleSaveFrameConfig();
        },
        onChangeImageBefore(url) {
            this.item.frameContent.beforePicture = url;
                            
            this.handleSaveFrameConfig();
        },
        onChangeImageAfter(url) {
            this.item.frameContent.afterPicture = url;
                            
            this.handleSaveFrameConfig();
        },
    },
    created() {
    },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/molecules/SettingsFrameBeforeAfterImage.vue